<ng-container *ngIf="documents && documents.length > 0; else noDoc">
  <div ngbDropdown container="body">
    <button class="btn bg-danger-custom btn-sm" ngbDropdownToggle>
      <i class="feather icon-file me-1"></i>Documents ({{ documents.length }})
    </button>
    <div ngbDropdownMenu class="doc-menu">
      <div *ngFor="let doc of documents" class="doc-row">
        <span class="doc-label" [title]="doc.type">{{ doc.type }}</span>
        <span class="badge me-1"
              [ngClass]="{
                'bg-success': doc.status === 'ACCEPTED',
                'bg-danger': doc.status === 'REJECTED',
                'bg-secondary': doc.status === 'PENDING' || !doc.status
              }">
          {{ doc.status || 'PENDING' }}
        </span>
        <button type="button" class="btn bg-danger-custom btn-icon btn-sm me-1"
                title="View" (click)="viewDoc(doc); $event.stopPropagation()">
          <i class="feather icon-eye"></i>
        </button>
        <button type="button" class="btn bg-danger-custom btn-icon btn-sm me-1"
                title="Download" (click)="downloadDoc(doc); $event.stopPropagation()">
          <i class="feather icon-arrow-down"></i>
        </button>
        <button type="button" class="btn btn-success btn-icon btn-sm me-1"
                title="Accept" [disabled]="userType === 'CUSTOMER' ? doc.status === 'ACCEPTED' : (doc.status === 'ACCEPTED' || updatingDocType === doc.type || (merchantStatus== 'ACTIVE' && 'BANK_DOC'!=doc.type))"
                (click)="updateDocStatus(doc, 'ACCEPTED'); $event.stopPropagation()">
          <i class="feather icon-check"></i>
        </button>
        <button type="button" class="btn btn-danger btn-icon btn-sm"
                title="Reject" [disabled]="doc.status === 'REJECTED' || updatingDocType === doc.type  || (merchantStatus== 'ACTIVE' && 'BANK_DOC'!=doc.type)"
                (click)="updateDocStatus(doc, 'REJECTED'); $event.stopPropagation()">
          <i class="feather icon-x"></i>
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #noDoc>
  <span class="text-muted no-doc">—</span>
</ng-template>
